import {Component} from '@angular/core';
import {ConfigService} from 'app/core/services/config.service';

@Component({
  selector: 'itpx-accounts',
  templateUrl: './accounts.component.html',
  styleUrls: ['./accounts.component.css']
})
export class AccountsComponent {

    private url: string;
    private detailsRoute: string = '/agora/account-data/accounts/{{key}}/details';
    private fields: Array<any> = [
        {
            title: 'Name',
            name: 'name',
            config: {
                type: 'link',
                route: this.detailsRoute,
                key: 'id'
            }
        }, {
            title: 'Additional Name',
            name: 'additionalName'
        }, {
            title: 'Account ID',
            name: 'accountId'
        }, {
            title: 'E-mail',
            name: 'email'
        }, {
            title: 'Domains',
            name: (data: any) => {
                if (data['domains'] && data['domains'][0]) {
                    return [data['domains'][0].name];
                } else {
                    return '';
                }
            }
        }
    ];

    constructor( private configService: ConfigService ) {
        this.url = this.configService.get('server').url + this.configService.get('endpoints').agora.accounts.list.api;
    }

}



// WEBPACK FOOTER //
// ./src/app/agora/components/account-data/accounts/accounts.component.ts